<template lang="pug">
.initial-loading
  .initial-loading-container
    img.initial-loading-logo(src="@/assets/img/emblem-white.svg")
    loader.initial-loading-loader(large)
  transition(name="fade")
    .initial-loading-error(v-if="configError !== null")
      span(v-if="configError === 'NO_APP'") Please assign the device to app...
</template>

<script>
import Loader from '@/components/Loader'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'InitialLoading',
  components: {
    Loader
  },
  computed: {
    ...mapGetters({
      configError: 'device/configError'
    })
  },
  created() {
    this.getDeviceHardware()
  },
  methods: {
    ...mapActions({
      getDeviceHardware: 'device/getDeviceHardware'
    })
  }
}
</script>

<style lang="scss">
.initial-loading {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .initial-loading-container {
    position: relative;
    max-width: 60%;
    margin: 0 auto;

    .initial-loading-logo {
      height: 5rem;
    }

    .initial-loading-loader {
      display: block;
      margin: 4rem auto 0;
    }
  }

  .initial-loading-error {
    position: absolute;
    left: 10%;
    right: 10%;
    bottom: 10%;
    text-align: center;
    font-size: 1.25rem;
    opacity: 0.5;
  }
}
</style>
